module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('engagements-dashboard', {
    attrs: {
      "selectedDate": _vm.selectedDate,
      "selectedPeriod": _vm.selectedPeriod,
      "selectedFilter": _vm.selectedFilter,
      "chartsData": _vm.chartsData,
      "mainChartData": _vm.mainChartData
    },
    on: {
      "previous": function($event) {
        return _vm.handlePrevious($event)
      },
      "next": function($event) {
        return _vm.handleNext($event)
      },
      "changePeriod": function($event) {
        return _vm.handleChangePeriod($event)
      },
      "changeFilter": function($event) {
        return _vm.handleChangeFilter($event)
      },
      "changeDate": function($event) {
        return _vm.handleChangeDate($event)
      }
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5a52608","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/containers/analytics/EngagementsContainer.vue
// module id = 3390
// module chunks = 3